module.exports = __webpack_public_path__ + "img/132ne.b5511660.svg";